(() => {
  'use strict';

  const exactTranslations = new Map([
    ['all shoes', 'الأحذية'],
    ['featured', 'المميزة'],
    ['shopping cart', 'سلة التسوق'],
    ['color', 'اللون'],
    ['size', 'المقاس'],
    ['availability', 'التوفر'],
    ['in stock', 'متوفر'],
    ['out of stock', 'غير متوفر'],
    ['price', 'السعر'],
    ['sort by', 'ترتيب حسب'],
    ['best selling', 'الأكثر مبيعًا'],
    ['alphabetically, a-z', 'أبجديًا: أ–ي'],
    ['alphabetically, z-a', 'أبجديًا: ي–أ'],
    ['price, low to high', 'السعر: من الأقل إلى الأعلى'],
    ['price, high to low', 'السعر: من الأعلى إلى الأقل'],
    ['date, old to new', 'الأقدم أولًا'],
    ['date, new to old', 'الأحدث أولًا']
  ]);

  const prefixTranslations = [
    [/^color\s*:/i, 'اللون:'],
    [/^size\s*:/i, 'المقاس:'],
    [/^in stock\s*\(/i, 'متوفر ('],
    [/^out of stock\s*\(/i, 'غير متوفر (']
  ];

  const skippedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'CODE', 'PRE']);

  const translateValue = (value) => {
    if (!value) return value;
    const trimmed = value.trim();
    if (!trimmed) return value;

    const exact = exactTranslations.get(trimmed.toLowerCase());
    let translated = exact || trimmed;

    if (!exact) {
      for (const [pattern, replacement] of prefixTranslations) {
        if (pattern.test(trimmed)) {
          translated = trimmed.replace(pattern, replacement);
          break;
        }
      }
    }

    if (translated === trimmed) return value;
    return value.replace(trimmed, translated);
  };

  const translateElementAttributes = (element) => {
    if (!(element instanceof Element)) return;
    ['aria-label', 'title', 'placeholder'].forEach((attribute) => {
      if (!element.hasAttribute(attribute)) return;
      const current = element.getAttribute(attribute);
      const translated = translateValue(current);
      if (translated !== current) element.setAttribute(attribute, translated);
    });
  };

  const translateTree = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      if (!root.parentElement || skippedTags.has(root.parentElement.tagName)) return;
      const translated = translateValue(root.nodeValue);
      if (translated !== root.nodeValue) root.nodeValue = translated;
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && skippedTags.has(root.tagName)) return;

    if (root.nodeType === Node.ELEMENT_NODE) translateElementAttributes(root);
    if (root.querySelectorAll) root.querySelectorAll('*').forEach(translateElementAttributes);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach((node) => {
      if (!node.parentElement || skippedTags.has(node.parentElement.tagName)) return;
      const translated = translateValue(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    });
  };

  const start = () => {
    translateTree(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          translateTree(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(translateTree);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
